module.exports = __webpack_public_path__ + "static/chunks/src/page-home/part-estimation-form/assets/shield-check.89ea28b90188838a2c4ba294b840f978.webp";